<template lang='pug'>
v-form(@submit.prevent='')
  v-container
    v-row
      v-col
        v-alert(
          v-if='isAnonymous'
          type='warning'
        )
          | Signed in as Guest
        v-alert(
          v-if='!isAnonymous'
          type='success'
        )
          | Signed in as {{ displayName }}
        v-btn(
          v-if='!isAnonymous'
          @click='signInAnonymously'
          block
          depressed
          outlined
        )
          | Sign out
  v-tabs(
    v-if='isAnonymous'
  )
    v-tab
      | Sign up
    v-tab
      | Sign in
    v-tab
      | Password?
    v-tab-item
      v-container
        v-row
          v-col
            label(
              for='email'
            )
              | Email
            v-text-field(
              v-model='email'
              type='email'
              id='email'
              outlined
            )
            label(
              for='password'
            )
              | Password
            v-text-field(
              v-model='password'
              type='password'
              id='password'
              outlined
            )
            v-btn(
              @click='signUp'
              :disabled='!shouldSubmit'
              block
              depressed
              outlined
            )
              | Sign up - It's free!
    v-tab-item
      v-container
        v-row
          v-col
            label(
              for='email'
            )
              | Email
            v-text-field(
              v-model='email'
              type='email'
              id='email'
              outlined
            )
            label(
              for='password'
            )
              | Password
            v-text-field(
              v-model='password'
              type='password'
              id='password'
              outlined
            )
            v-btn(
              @click='signIn'
              :disabled='!shouldSubmit'
              block
              depressed
              outlined
            )
              | Sign in
    v-tab-item
      v-container
        v-row
          v-col
            label(
              for='passwordResetEmail'
            )
              | Email
            v-text-field(
              v-model='email'
              type='email'
              id='passwordResetEmail'
              outlined
            )
            v-btn(
              @click='sendPasswordResetEmail'
              :disabled='!email'
              block
              depressed
              outlined
            )
              | Reset password
  v-container(
    v-if='shouldShowPasswordResetAlert || errorMessage'
  )
    v-row
      v-col
        v-alert(
          v-if='shouldShowPasswordResetAlert'
          type='success'
        )
          | Password reset email sent
        v-alert(
          v-if='errorMessage'
          type='error'
        )
          | {{ errorMessage }}
  v-container(
    v-if='isAnonymous'
  )
    v-row(
      align='center'
    )
      v-col
        v-divider
      v-col(
        cols='auto'
      )
        | or
      v-col
        v-divider
    v-row
      v-col
        v-btn(
          @click='signInWithPopup'
          block
          depressed
          outlined
        )
          | Continue with Google
</template>

<script>
import { cond, get, negate, noop, pipe, replace, stubFalse, stubTrue } from 'lodash/fp';

import {
  signInAnonymously,
} from '../functions/signInAnonymously';

import {
  createUserWithEmailAndPassword,
} from '../functions/createUserWithEmailAndPassword';

import {
  signInWithEmailAndPassword,
} from '../functions/signInWithEmailAndPassword';

import {
  sendPasswordResetEmail as _sendPasswordResetEmail,
} from '../functions/sendPasswordResetEmail';

import {
  signInWithRedirect as _signInWithRedirect,
} from '../functions/signInWithRedirect';

import {
  app,
} from '../functions/initializeApp';

import {
  getAuth,
  onAuthStateChanged,
  // FacebookAuthProvider,
  GoogleAuthProvider,
  signInWithPopup as _signInWithPopup,
} from 'firebase/auth';

const signInWithPopup = function ()
{
  _signInWithPopup(getAuth(app), new GoogleAuthProvider()).catch(noop);
};

const signUp = function ()
{
  this.error = null;

  createUserWithEmailAndPassword
  (this.email)
  (this.password)
  .catch(error => this.error = error);
};

const signIn = function ()
{
  this.error = null;

  signInWithEmailAndPassword
  (this.email)
  (this.password)
  .catch(error => this.error = error);
};

const sendPasswordResetEmail = function ()
{
  this.error = null;

  _sendPasswordResetEmail(this.email)
  .then(() => this.shouldShowPasswordResetAlert = true)
  .catch(error => this.error = error);
};

const signInWithRedirect = function ()
{
  // const provider = new FacebookAuthProvider();
  const provider = new GoogleAuthProvider();

  _signInWithRedirect(provider);
};

const errorMessage = function ()
{
  return pipe
  ([
    get('error.message'),
    replace
    ('Firebase: Error (auth/email-already-in-use).')
    ('Email already in use.'),
    replace
    ('Firebase: Error (auth/invalid-email).')
    ('Invalid email.'),
    replace
    ('Firebase: Error (auth/user-not-found).')
    ('User not found.'),
    replace
    ('Firebase: Error (auth/wrong-password).')
    ('Wrong password.'),
  ])
  (this);
};

const isAnonymous = function ()
{
  return get
  ('user.isAnonymous')
  (this);
};

const shouldSubmit = function ()
{
  return cond
  ([
    [negate(get('email')), stubFalse],
    [negate(get('password')), stubFalse],
    [stubTrue, stubTrue],
  ])
  (this);
};

const displayName = function ()
{
  return cond
  ([
    [get('user.displayName'), get('user.displayName')],
    [get('user.email'), get('user.email')],
  ])
  (this);
};

const mounted = function ()
{
  const auth = getAuth(app);

  this.unsubscribe = onAuthStateChanged
  (
    auth,
    user => this.user = user
  );
};

const destroyed = function ()
{
  this.unsubscribe();
};

export default
{
  computed:
  {
    displayName,
    errorMessage,
    isAnonymous,
    shouldSubmit,
  },
  mounted,
  data()
  {
    return {
      email: null,
      error: null,
      password: null,
      shouldShowPasswordResetAlert: false,
      unsubscribe: null,
      user: null,
    };
  },
  destroyed,
  methods:
  {
    sendPasswordResetEmail,
    signIn,
    signInAnonymously,
    signInWithPopup,
    signInWithRedirect,
    signUp,
  },
};
</script>